import type { Ref } from "vue";
import { OrganizationType } from "~/modules/organization/models/OrganizationType.enum";
import type { OrganizationTypeOption } from "~/modules/organization/models/OrganizationTypeOption.interface";

export const PATH_ORGANIZATIONS = "/organizations";
export const PATH_ORGANIZATIONS_ID = `${PATH_ORGANIZATIONS}/:id`;
export const PATH_ORGANIZATIONS_ID_SETTINGS = `${PATH_ORGANIZATIONS_ID}/settings`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_INFORMATION = `${PATH_ORGANIZATIONS_ID_SETTINGS}/information`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_LOGS = `${PATH_ORGANIZATIONS_ID_SETTINGS}/logs`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_LICENSE = `${PATH_ORGANIZATIONS_ID_SETTINGS}/license`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USERS = `${PATH_ORGANIZATIONS_ID_SETTINGS}/users`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN = `${PATH_ORGANIZATIONS_ID_SETTINGS_USERS}/:userLogin`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_INFORMATION = `${PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN}/information`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_DELEGATION = `${PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN}/delegation`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS = `${PATH_ORGANIZATIONS_ID_SETTINGS}/relations`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_AFFILIATIONS = `${PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS}/affiliations`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_DELEGATIONS = `${PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS}/delegations`;

export const typeOptions: Ref<OrganizationTypeOption[]> = ref([
  {
    key: OrganizationType.ADMINISTRATION,
    labelKey: "administration.organization.type.administration",
  },
  {
    key: OrganizationType.OPERATOR,
    labelKey: "administration.organization.type.operator",
  },
]);
